<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../../../configs/text';
import { useClassStore, useQuizStore, useUserStore } from '../../../../../stores';
import { UserRole } from '../../../../../types/user';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { utils } from '../../../../../utils';


const { t } = useI18n()
const quizStore = useQuizStore()
const userStore = useUserStore()
const classStore = useClassStore()

const { selectedClassDetails: classDetails } = storeToRefs(classStore)

const studentOnline = computed(() => classDetails.value?.students?.filter((student) => student.connected).length || 0);

</script>

<template>
    <table>
        <tbody>
            <tr>
                <td class="font-bold p-2 first-letter:uppercase">{{ `${t(TEXT.quiz_number_question)}:` }}</td>
                <td>{{ `${quizStore.quiz?.questions.length} ${t(TEXT.questions)}` }}</td>
            </tr>
            <tr>
                <td class="font-bold p-2 first-letter:uppercase">{{ `${t(TEXT.quiz_total_point)}:` }}</td>
                <td>{{ `${quizStore.quiz.totalPoint} ${t(TEXT.pts)}` }}</td>
            </tr>
            <tr>
                <td class="font-bold p-2 first-letter:uppercase">{{ `${t(TEXT.quiz_total_time)}:` }}</td>
                <td>{{ utils.formatSecondsToMinuteSeconds(quizStore.quiz.totalTime, 'mmms') }}</td>
            </tr>
            <slot name="settings">
                <tr v-if="userStore.userRole === UserRole.teacher">
                    <td class="font-bold p-2">{{ `${t(TEXT.students)}:` }}</td>
                    <td>{{ `${studentOnline} / ${classStore.attendedStudentCount} ${t(TEXT.quiz_online)}`
                    }}
                    </td>
                </tr>
            </slot>
        </tbody>
    </table>
</template>